import { IParamsGetDiscountVoucher } from 'app/api/marketing/discount-voucher/model'
import { ParamsList } from 'parkway-web-common'

export const VoucherKeys = {
  allVouchers: ['Vouchers'] as const,
  listVoucher: () =>
    [...VoucherKeys.allVouchers, 'VouchersList'] as const,
  listVouchers: (filter?: IParamsGetDiscountVoucher) =>
    [...VoucherKeys.listVoucher(), { filter }] as const,


  listVoucherFilter: () =>
    [...VoucherKeys.allVouchers, 'VouchersList'] as const,
  listVoucherFilters: (filter?: ParamsList) =>
    [...VoucherKeys.listVoucherFilter(), { filter }] as const,
}
